import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

const NotificationToastDonation = ({
	notification,
}) => {
	const {
		data: {
			amounts,
		},
	} = notification;

	const amount = useMemo(() => amounts?.piPoints || 0, [amounts]);
	const amountChips = useMemo(() => amounts?.chips || 0, [amounts]);

	const donationMessageTranslationKey = useMemo(() => {
		if (amount && amountChips) {
			return 'Toast.Donation.donatedCombinedAmount';
		} if (amount) {
			return 'Toast.Donation.donatedPiAmount';
		}

		return 'Toast.Donation.donatedChipsAmount';
	}, [amount, amountChips]);

	return (
		<div className="d-flex align-items-center justify-content-between">
			<div>
				<Trans i18nKey={donationMessageTranslationKey}>
					I donated {{ amount }} Pi and {{ amountChips }} chips to your channel
				</Trans>
			</div>
		</div>
	);
};

NotificationToastDonation.propTypes = {
	notification: PropTypes.shape({
		data: PropTypes.shape({
			amounts: PropTypes.shape({
				piPoints: PropTypes.number,
				chips: PropTypes.number,
			}),
		}).isRequired,
	}).isRequired,
};

export default NotificationToastDonation;
